import { useInfiniteQuery, type InfiniteData } from '@tanstack/react-query';
import { listNotifications, type NotificationPageDto } from '@api/notifications';
import { notificationKeys } from './notificationQueryKeys';

const PAGE_SIZE = 20;

/**
 * Paginated, infinite-scrolling list of the current user's notifications.
 * Pass {@code unreadOnly} to filter to unread items only.
 */
export function useNotifications(unreadOnly = false) {
  return useInfiniteQuery<
    NotificationPageDto,
    Error,
    InfiniteData<NotificationPageDto>,
    ReturnType<typeof notificationKeys.list>,
    number
  >({
    queryKey: notificationKeys.list(unreadOnly),
    initialPageParam: 0,
    queryFn: ({ pageParam }) => listNotifications(pageParam, PAGE_SIZE, unreadOnly),
    getNextPageParam: (last) => (last.hasNext ? last.page + 1 : undefined),
    staleTime: 30_000,
  });
}
